import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { styled } from "@mui/material/styles";
import {
  COLOR_BLACK_10,
  COLOR_GREY_11,
  COLOR_PRIMARY_BACKGROUND,
  COLOR_PRIMARY_MAIN,
  COLOR_WHITE,
} from "shared/theme/colors";

export const StyledTabs = styled(Tabs)`
  margin-top: 1rem;
  padding: 0 1.5rem;

  border-bottom: 1px solid ${COLOR_BLACK_10};
  .MuiButtonBase-root.Mui-selected {
    color: ${COLOR_PRIMARY_MAIN};
    background-color: ${COLOR_PRIMARY_BACKGROUND};
  }
`;

export const StyledTab = styled(Tab)`
  padding: 0 1rem;
  color: ${COLOR_GREY_11};
  border-radius: 0.5rem 0.5rem 0 0;
  min-width: 0;
  text-transform: none;
  font-size: 0.875rem;
  font-weight: 500;
  max-height: 40px;
  min-height: 40px;
  margin-top: 8px;
  gap: 0 10px;

  svg {
    fill: ${COLOR_WHITE};
  }
`;
